export default function AboutSection() {
  const stats = [
    { value: "iOS", label: "Platform Focus" },
    { value: "100%", label: "Security Focused" },
    { value: "24/7", label: "App Availability" },
  ];

  return (
    <section id="about" className="w-full py-28 bg-white">
      <div className="max-w-7xl mx-auto px-10">
        {/* Label */}
        <p className="text-xs uppercase tracking-widest text-gray-400 font-medium mb-5">
          &bull;&nbsp; Who We Are
        </p>

        {/* Two-column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: text */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-tight mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
              Specialists in creating secure &amp; intuitive iOS applications
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-5">
              <strong>ROXTVEL d.o.o. Pirot</strong> is a dedicated team of software engineers and designers
              based in Serbia, laser-focused on developing premium applications for the iOS ecosystem.
              We believe that great software must be both powerful and invisible — working flawlessly
              in the background while users enjoy their devices to the fullest.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              Our mission is to deliver tools that protect users&apos; privacy, optimize device
              performance, and set new standards for mobile security. Every product we ship
              reflects our commitment to quality craftsmanship and user-first design.
            </p>

            {/* Stats row */}
            <div className="grid grid-cols-3 gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-[#F7F7F7] rounded-xl p-4 text-center">
                  <div className="text-2xl font-bold text-[#1A1A1A] mb-1">{stat.value}</div>
                  <div className="text-xs text-gray-400 uppercase tracking-wide">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: image */}
          <div className="relative w-full h-[420px] rounded-2xl overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/3c7fcd9ba010d8c01d2cdfd432a73499.jpg"
              alt="ROXTVEL d.o.o. Pirot team workspace"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
            {/* Company tag */}
            <div className="absolute bottom-5 left-5 bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 flex items-center gap-2">
              <img
                src="https://public.readdy.ai/ai/img_res/4d56948f-f323-4cfa-8fd6-32510aea7808.png"
                alt="ROXTVEL logo"
                className="h-6 w-auto object-contain"
              />
              <span className="text-xs font-semibold text-[#1A1A1A]">ROXTVEL d.o.o. Pirot</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
